// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} SMSMessageRecipient
 * @property {string} id
 * @property {'medical-patient'|'account'} type
 * @property {string} address
 * @property {number} sentAt
 */

/**
 * @typedef {Object} SMSMessage
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} organization
 * @property {string} provider
 * @property {number} message
 * @property {number} sentAt
 * @property {number} arrivedAt
 * @property {string} error
 * @property {SMSMessageRecipient[]} recipients
 */

const state = {
  /** @type {SMSMessage[]} */
  messages: []
};

export default state;
